import { ModuleData } from '../../Types/containerV2';
import { isIFrameModuleContent } from '../../Types/containerV2/modules/iframe';
import './IFrameModule.scss';

type IFrameModuleProps = {
	module: ModuleData;
};

function getQueryStringValue(name: string | undefined): string {
	if (!name || typeof window === 'undefined') return '';
	return new URLSearchParams(window.location.search).get(name) ?? '';
}

const IFrameModule = ({ module }: IFrameModuleProps) => {
	if (!isIFrameModuleContent(module.content)) {
		return null;
	}

	const { iframeSrc, useQueryString, queryStringName } = module.content;
	const source = useQueryString ? getQueryStringValue(queryStringName) : iframeSrc;

	return (
		<div className='biz-module biz-iframe-module'>
			{source && (
				<iframe
					className='biz-iframe-module__frame'
					src={source}
					title='Embedded content'
					frameBorder='0'
				/>
			)}
		</div>
	);
};

export default IFrameModule;
